import React from 'react';
import Modal from '@common/modal';
import Text from '@common/text';
import Button from '@common/button';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import { useKeyDown } from '@utils/hooks/useKeyboard';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

interface ConfirmModalProps {
  visible: boolean;
  onClick: () => void;
  onClose: () => void;
}

const ConfirmModal = ({ visible, onClick, onClose }: ConfirmModalProps) => {
  useKeyDown(onClose, 'Escape');

  return (
    <Modal visible={visible}>
      <div className={cx('modalArea')}>
        <div className={cx('textArea')}>
          <Text fontStyle={FontStyle.H4_B}>인증정보를 삭제하시겠어요?</Text>
          <Text fontStyle={FontStyle.B2P_M} color={Colors.C_COOL_GRAY_70}>
            삭제된 인증코드는 다시 사용할 수 없어요.
          </Text>
        </div>

        <div className={cx('btnArea')}>
          <Button className={cx('btn')} theme={'secondary'} type={'button'} onClick={onClose}>
            취소
          </Button>
          <Button className={cx('btn')} type={'button'} onClick={onClick}>
            확인
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmModal;
